<template>
  <div
    v-if="active"
    class="pwa-prompt"
  >
    <div class="pwa-backdrop" />
    <div class="pwa-container">
      <div class="pwa-close-wrapper">
        <button
          class="pwa-close"
          @click="close()"
        >
          <div class="icon">
            <i class="mdi mdi-close" />
          </div>
        </button>
      </div>
      <div class="pwa-box">
        <div class="pwa-box-body">
          <img
            src="/img/icons/maskable_icon.png"
            alt="SAUVéR logo"
            class="pwa-icon mb-4"
          >
          <h2 class="title is-6 mb-4">
            {{ $t('pwa.title') }}
          </h2>
          <p class="has-text-grey is-size-7">
            {{ $t('pwa.text') }}
          </p>
        </div>
        <div class="pwa-box-footer">
          {{ $t('pwa.tap') }} <img
            src="/img/icons/apple-share.png"
            alt="Share button"
            width="18"
            class="_inline"
            style="margin: 0 1px; position:relative; top: 3px;"
          > {{ $t('pwa.add_to_home_screen') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { canShow, hide } from "@/services/pwaPrompt";

export default {
  data () {
    return {
      active: false
    };
  },
  created () {
    if (canShow()) {
      this.active = true;
    }
  },
  methods: {
    close () {
      hide();
      this.active = false;
    }
  }
};
</script>

<style lang="scss" scoped>

@import "~/scss/variables";


.pwa-prompt {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  z-index: 999;
  width: 100%;
  height: 100%;
}

.pwa-backdrop {
  background-color: #000;
  opacity: 0.5;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.pwa-container {
  position: relative;
  max-width: 300px;
  margin: 0 auto;
}

.pwa-close-wrapper {
  text-align: right;
}

.pwa-close {
  color: white;
  font-size: 20px;
  outline: none;
  background: none;
  appearance: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.pwa-box {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 1px rgba(0,0,0,0.1);
  overflow: hidden;
}

.pwa-box-body {
  padding: 1.5rem;
  text-align: center;
}

.pwa-icon {
  display: inline-block;
  height: 60px;
  width: 60px;
  border-radius: 9px;
  box-shadow: 1px 1px 5px rgba(0,0,0,0.2);
}

.pwa-box-footer {
  background-color: $white-dark;
  font-size: 14px;
  text-align: center;
  padding: 1rem;
  padding-top: 0.4rem;
}

</style>
